import { WaIcon } from "./Nav";
import { WHATSAPP_LINK } from "@/config";

const FloatingWhatsApp = () => (
  <a
    href={WHATSAPP_LINK}
    target="_blank"
    rel="noreferrer"
    data-testid="floating-whatsapp"
    aria-label="Pedir cita por WhatsApp"
    className="fixed bottom-5 right-5 z-50 inline-flex h-14 w-14 items-center justify-center rounded-full bg-wa text-[#06120b] shadow-[0_8px_30px_rgba(37,211,102,0.45)] transition-all duration-300 hover:scale-110"
  >
    <WaIcon size={26} />
  </a>
);

export default FloatingWhatsApp;
